// src/pages/PrivacyPolicy.jsx
import { Box, Container, Title, Text, Stack, List } from "@mantine/core";

export default function PrivacyPolicy() {
  return (
    <Box style={{ backgroundColor: "#f0ede8", minHeight: "100vh" }}>
      <Container size="md" py={60}>
        <Stack gap={32}>

          <Stack gap={8}>
            <Title order={1} fw={900} c="#1a1a1a">Privacy Policy</Title>
            <Text c="#888" size="sm">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</Text>
          </Stack>

          <Text c="#555" style={{ lineHeight: 1.8 }}>
            RentalFlow ("we", "our", or "us") is committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, and safeguard your information 
            when you use our mobile application and web services.
          </Text>

          {/* Section 1 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">1. Information We Collect</Title>
            <Text c="#555" style={{ lineHeight: 1.8 }}>We collect the following information:</Text>
            <List spacing="sm" c="#555">
              <List.Item>Name, phone number, and email address of shop owners</List.Item>
              <List.Item>Customer name, phone number, and email address for booking purposes</List.Item>
              <List.Item>Government ID documents (Aadhaar card, Driving Licence) uploaded by customers for KYC verification</List.Item>
              <List.Item>Vehicle information including registration numbers and photos</List.Item>
              <List.Item>Pre-ride vehicle condition photos</List.Item>
              <List.Item>Booking and ride history</List.Item>
            </List>
          </Stack>

          {/* Section 2 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">2. How We Use Your Information</Title>
            <List spacing="sm" c="#555">
              <List.Item>To facilitate vehicle rental bookings between shops and customers</List.Item>
              <List.Item>To verify customer identity through KYC documents</List.Item>
              <List.Item>To send OTP verification via SMS or email</List.Item>
              <List.Item>To generate booking reports for rental shop owners</List.Item>
              <List.Item>To improve our services and user experience</List.Item>
            </List>
          </Stack>

          {/* Section 3 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">3. Data Storage and Security</Title>
            <Text c="#555" style={{ lineHeight: 1.8 }}>
              All data is stored securely on Google Cloud Platform servers located in India (asia-south1 region). 
              Documents and images are stored in private Google Cloud Storage buckets and are not publicly accessible. 
              Passwords are BCrypt hashed — we cannot see your password.
            </Text>
          </Stack>

          {/* Section 4 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">4. Data Sharing</Title>
            <Text c="#555" style={{ lineHeight: 1.8 }}>
              We do not sell, trade, or share your personal information with third parties except:
            </Text>
            <List spacing="sm" c="#555">
              <List.Item>With the rental shop owner associated with your booking</List.Item>
              <List.Item>When required by law or government authorities</List.Item>
              <List.Item>With service providers (Google Cloud, email service) necessary to operate our platform</List.Item>
            </List>
          </Stack>

          {/* Section 5 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">5. Camera and Storage Permissions</Title>
            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Our app requests camera permission to capture pre-ride vehicle condition photos. 
              These photos are used solely for documenting vehicle condition before and after each ride. 
              We do not access your camera without your explicit action.
            </Text>
          </Stack>

          {/* Section 6 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">6. Data Retention</Title>
            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Booking records and customer information are retained for as long as the rental shop 
              maintains an active account with RentalFlow. Shop owners may request deletion of 
              customer data by contacting us.
            </Text>
          </Stack>

          {/* Section 7 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">7. Your Rights</Title>
            <List spacing="sm" c="#555">
              <List.Item>Request access to your personal data</List.Item>
              <List.Item>Request correction of inaccurate data</List.Item>
              <List.Item>Request deletion of your data</List.Item>
              <List.Item>Withdraw consent at any time</List.Item>
            </List>
          </Stack>

          {/* Section 8 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">8. Contact Us</Title>
            <Text c="#555" style={{ lineHeight: 1.8 }}>
              If you have any questions about this Privacy Policy or how we handle your data, 
              please contact us:
            </Text>
            <Text c="#f24c1a" fw={700}>Instagram: @rentalflow.in</Text>
            <Text c="#f24c1a" fw={700}>Phone: +91 8172818877</Text>
            <Text c="#f24c1a" fw={700}>Website: rentalflow.in</Text>
            <Text
            component="a"
            href="mailto:help@rentalflow.in"
            c="#f24c1a"
            fw={700}
            style={{ textDecoration: "none" }}
            >
            Email: help@rentalflow.in
            </Text>
          </Stack>

          {/* Section 9 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">9. Changes to This Policy</Title>
            <Text c="#555" style={{ lineHeight: 1.8 }}>
              We may update this Privacy Policy from time to time. We will notify users of 
              any significant changes by updating the date at the top of this page.
            </Text>
          </Stack>

        </Stack>
      </Container>

      {/* Footer */}
      <Box py={24} style={{ borderTop: "1px solid #e0ddd8" }}>
        <Container>
          <Text ta="center" size="sm" c="#777">
            © {new Date().getFullYear()} RentalFlow · Smart Rentals Made Simple
          </Text>
        </Container>
      </Box>
    </Box>
  );
}